import { GET_PARTNER_USERS_STATS, useGetCurrentUserProfile } from '@/api/query'
import { useSession } from '@/context/SessionProvider'
import { AppModals, useAppModal } from '@/context/ModalProvider'
import { Box, Container, VStack } from '@chakra-ui/react'
import { useCallback, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { AppMessages, useAppToast } from '@/hooks/useAppToast'
import { AffiliateOverviewTab } from '@/components/affiliate/AffiliateOverviewTab'
import { AffiliateUsersTable } from '@/components/affiliate/AffiliateUsersTable'
import { AffiliatePartnershipBanner } from '@/components/affiliate/AffiliatePartnershipBanner'

export default function AffiliatePage() {
  const { onSuccess } = useAppToast()
  const modal = useAppModal()
  const { account, signIn } = useSession()
  const { data: user } = useGetCurrentUserProfile()

  const { data: partnerStats, loading: loadingPartnerStats } = useQuery(GET_PARTNER_USERS_STATS, {
    skip: account?.injectiveAddress == undefined,
    variables: {
      partnerAddress: account?.injectiveAddress || '',
      startDate: '2020-05-01T00:00:00+00:00',
      endDate: '2100-06-01T00:00:00+00:00',
    },
  })

  const affiliateLink = user ? `${window?.location?.origin}/?r=${user?.profile?.user_name}` : ''

  const handleClickWallet = useCallback(async () => {
    signIn()
  }, [signIn])

  const handleCopy = (link: string) => {
    navigator.clipboard.writeText(link)
    onSuccess({ key: AppMessages.TextCopied })
  }

  const handleUserClick = (user: any) => {
    modal.openModalNew(AppModals.UserStats, { address: user.userId })
  }

  return (
    <Box bg="ninja.1000" minH="100vh">
      <Container maxW="container.xl" py={8}>
        <VStack spacing={10} align="stretch">
          <AffiliateOverviewTab
            account={account}
            partnerData={{}}
            affiliateLink={affiliateLink}
            onCopy={handleCopy}
            onConnectWallet={handleClickWallet}
          />

          {account && (
            <>
              <AffiliateUsersTable
                partnerStats={partnerStats}
                loading={loadingPartnerStats}
                onUserClick={handleUserClick}
              />
              <AffiliatePartnershipBanner />
            </>
          )}
        </VStack>
      </Container>
    </Box>
  )
}
